/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Capabilities_DescriptionInputs */

const en_mcp_capabilities_description = /** @type {(inputs: Mcp_Capabilities_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listen on your commute, on a walk or at the gym instead of at your desk.`)
};

const es_mcp_capabilities_description = /** @type {(inputs: Mcp_Capabilities_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escucha en el trayecto, de paseo o en el gimnasio en lugar de frente a tu escritorio.`)
};

/**
* | output |
* | --- |
* | "Listen on your commute, on a walk or at the gym instead of at your desk." |
*
* @param {Mcp_Capabilities_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_capabilities_description = /** @type {((inputs?: Mcp_Capabilities_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Capabilities_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_capabilities_description(inputs)
	return en_mcp_capabilities_description(inputs)
});